import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import CustomHeader from '../components/Header'
import axiosConfig from '../config/axiosConfig';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Card, Row,Col } from 'react-bootstrap';
import { sha256, sha224 } from 'js-sha256';
import { Link } from 'react-router-dom'; // Add this line


class UpdatePassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            middleName: '',
            lastName: '',
            email: '',
            mobileNo: '',
            existingPassword:'',
            newPassword:'',
            cnewPassword:''

        }


        this.ChaneHandler = this.ChaneHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
    }

    ChaneHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
    }

    submitHandler = e => {
        e.preventDefault();

        if(this.validate())
        {

        if(this.state.newPassword!=this.state.cnewPassword)
        {
            Swal.fire({
                title: 'Error !',
                text: 'Password Not Matched.',
                icon: 'error',
                confirmButtonText: 'Okay'
            })
            return false;
        }



        let token=localStorage.getItem('token');
        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post('Portal/ResetPassword', {
            PreviousPassword: sha256(this.state.existingPassword),
            Password: sha256(this.state.newPassword)
        })
            .then((res) => {
                console.log(res.data)
                Swal.fire({
                    icon: 'success',
                    title: 'Password Changed Successfully',
                })
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
            .finally(() => {
                //console.log(this.state.accounts)
                console.log(this.state)
            });

        }
    }


    validate(){
        let input = this.state;
        let errors = {};
        let isValid = true;
     
      

        let al=input["newPassword"].length;
        if(input["newPassword"].length < 8)
        {
            isValid = false;
            errors["newPassword"] = "Your password must be atleast 8 character long.";
            this.setState({
                errors: errors
              });
            return;
        }

        if(!input["newPassword"].match(/[A-Z]/))
        {
            isValid = false;
            errors["newPassword"] = "Your password must contain at least 1 uppercase letter.";
            this.setState({
                errors: errors
              });
            return;
        }
        if(!input["newPassword"].match(/[a-z]/))
        {
            isValid = false;
            errors["newPassword"] = "Your password must contain at least 1 lowercase letter.";
            this.setState({
                errors: errors
              });
            return;
        }
        if(!input["newPassword"].match(/[\d`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/))
        {
            isValid = false;
            errors["newPassword"] = "Your password must contain At least 1 number or special character";
            this.setState({
                errors: errors
              });
            return;
        }
        
        if (input["newPassword"] !== "undefined" && input["cnewPassword"] !== "undefined") {
            
            if (input["newPassword"] != input["cnewPassword"]) {
              isValid = false;
              errors["newPassword"] = "Passwords don't match.";
              this.setState({
                errors: errors
              });
            return;
            }
          } 

        if(isValid)
        {
            errors = {};
            this.setState({
                errors: errors
              });
        }
    
      
    
        // this.setState({
        //   errors: errors
        // });
    
        return isValid;
    }


    render() {

        const { existingPassword,newPassword,cnewPassword} = this.state;
        let colour1="red",colour2="red",colour3="red",colour4="red",colour5="red";
        if(this.state.newPassword.length >= "8")
        {
            colour1="green";    
        }
        if(this.state.newPassword.match(/[A-Z]/))
        {
            colour2="green";    
        }
        if(this.state.newPassword.match(/[a-z]/))
        {
            colour3="green";    
        }
        if(this.state.newPassword.match(/[\d`~!@#$%\^&*()+=|;:'",.<>\/?\\\-]/))
        {
            colour4="green";    
        }
        if(this.state.newPassword === this.state.cnewPassword && this.state.newPassword!=="" )
        {
            colour5="green";    
        }
  
        const style={
            boxShadow:"2px 2px 3px 3px #ccc",
            border:"2px #eee",
            padding:"20px",
            marginTop:"25px"
        }
        return (
            <>

                {/* <CustomHeader>

                </CustomHeader> */}
                <div style={{ textAlign: 'left', marginLeft: '30px' }}>

<Link to="/Administration" className="btn btn-shell mr-1 mb-1">Back</Link> {/* Add this line */}

</div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">My Profile(Change Password)</h4>
                                </div>
                                <div className="card-content">
                                    <div className="card-body"></div>
                                    <form className="form" onSubmit={this.submitHandler} >
                                        <div className="form-body">

                                        <Row>
                                            <p style={{fontWeight:"bold"}}>All checkmarks must turn green, password must have:</p>
                                        </Row>
                                        <Row>
                                            <p><i style={{color:colour1}} className="fa fa-check-circle" aria-hidden="true"></i> <small>At least 8 characters</small>   &nbsp;  </p> 
                                            <p><i style={{color:colour2}} className="fa fa-check-circle" aria-hidden="true"></i> <small> At least 1 uppercase letter</small> &nbsp;</p>
                                            <p><i style={{color:colour3}} className="fa fa-check-circle" aria-hidden="true"></i><small> At least 1 lowercase letter</small> &nbsp;</p>
                                            <p><i style={{color:colour4}} className="fa fa-check-circle" aria-hidden="true"></i><small> At least 1 number or special character</small> &nbsp;</p>
                                            <p><i style={{color:colour5}} className="fa fa-check-circle" aria-hidden="true"></i><small> Password is equal to Confirm Password</small> &nbsp;</p>
                                        </Row>
                                        <Row>
                                                <div className="col-md-6 col-12" id="text">
                                                    <div className="form-label-group">
                                                        <input type="password" className="form-control" name="existingPassword" value={this.state.existingPassword} onChange={this.ChaneHandler} placeholder="Enter Existing Password" />
                                                        <label htmlFor="company-column">Enter Existing Password</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-12" id="text">&nbsp;</div>
                                                <div className="col-md-6 col-12" id="text2">
                                                    <div className="form-label-group">
                                                        <input type="password" className="form-control" name="newPassword" value={this.state.newPassword} onChange={this.ChaneHandler} autocomplete="new-password" placeholder="Enter New Password" />
                                                        <label htmlFor="company-column">Enter New Password</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-12" id="text2">
                                                    <div className="form-label-group">
                                                        <input type="password" className="form-control" name="cnewPassword" value={this.state.cnewPassword} onChange={this.ChaneHandler} placeholder="Confirm New Password" autocomplete="new-password" />
                                                        <label htmlFor="company-column">Confirm New Password</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-6 col-12">
                                                </div>

                                                <div className="col-12" style={{ textAlign: 'left' }}>
                                                    <button type="submit" className="btn btn-shell mr-1 mb-1">Confirm</button>
                                                </div>
                                        </Row>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>

        );
    }
}

export default UpdatePassword;









